module.exports = __webpack_public_path__ + "static/media/logo-black.3afe75ec.svg";